import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover, Typography } from "antd";
import classNames from "classnames";

import { TranslateCost } from "@/modules/translate";

const { Text } = Typography;

const ProjectCostLine = ({ name, value, color, subCosts, textsClassName }) => {
  return (
    <>
      <Text ellipsis className={classNames("title", textsClassName)}>
        {subCosts?.length > 0 && (
          <Popover
            title={name}
            content={
              <div className="project-costs-card-grid">
                {subCosts.map((cost) => (
                  <ProjectCostLine
                    key={`${cost.name}-${cost.value}`}
                    {...cost}
                  />
                ))}
              </div>
            }
          >
            <InfoCircleOutlined />
          </Popover>
        )}
        {name}
      </Text>
      <div className="chip-color" style={{ backgroundColor: color }} />
      <Text className={classNames("cost", textsClassName)}>
        <TranslateCost value={value} />
      </Text>
    </>
  );
};

export default ProjectCostLine;
